import { RootState } from '~/store';

export const activateCatalogTimerDiscountSelector = (state: RootState) => state.finance.activateCatalogTimerDiscount;
